import { useEffect } from "react";

export default function Seo({ title, siteName, description, image, jsonLd }) {
  useEffect(() => {
    const url = window.location.origin + window.location.pathname;
    const head = document.head;
    const managed = [];

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        head.appendChild(el);
        managed.push(el);
      }
      el.setAttribute("content", content);
    };

    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", siteName);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image ? window.location.origin + image : null);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image ? window.location.origin + image : null);

    let canonical = head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      head.appendChild(canonical);
      managed.push(canonical);
    }
    canonical.setAttribute("href", url);

    let ld;
    if (jsonLd) {
      ld = document.createElement("script");
      ld.setAttribute("type", "application/ld+json");
      ld.textContent = JSON.stringify(jsonLd);
      head.appendChild(ld);
      managed.push(ld);
    }
  }, [title, siteName, description, image, jsonLd]);

  return null;
}
